{
  "version": 1,
  "asset_id": "59456c8a-666d-4c98-a4e4-f14bc112161c",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/59456c8a-666d-4c98-a4e4-f14bc112161c/bypass-revision-downsizing-en.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/59456c8a-666d-4c98-a4e4-f14bc112161c/bypass-revision-downsizing-en.webp",
  "original_filename": "bypass-revision-downsizing-en.webp",
  "size": 207102,
  "content_type": "image/webp",
  "created_at": "2026-10-05T22:11:37Z"
}
